module.exports = __webpack_public_path__ + "img/tn-timeline-main-6.7042d7fd.jpg";